import React from "react"
import { ITextProps } from "../../types/textTypes"
import mapStylesFromProps from "../../utils/mapStylesFromProps"

interface Props extends ITextProps {}

const Header1 = (props: Props) => {
  const className = `font-jost-medium text-2xl sm:text-3xl md:text-4xl lg:text-5xl ${mapStylesFromProps(
    props
  )}`
  return <span className={className}>{props.children}</span>
}

export default Header1
